/* PC-FILAMENT-STOCK-24 v1.0.1: stock filtering survives popup CSS and inventory refresh. */
(function (global) {
  'use strict';
  const SCHEMA='popcubby-filament-availability/1', CACHE='pc:filament-availability:v1';
  let current=null,loading=null;
  const decorated=new Map();
  function valid(doc){return !!(doc&&doc.schema===SCHEMA&&typeof doc.revision==='string'&&Array.isArray(doc.colors)&&doc.colors.length&&doc.colors.every(c=>/^#[0-9A-F]{6}$/.test(c.hex)&&typeof c.available==='boolean')&&doc.colors.some(c=>c.available));}
  function accept(doc){if(!valid(doc))throw Error('Invalid color availability');current=doc;for(const [element,record]of decorated){if(!element.isConnected){decorated.delete(element);continue;}applyDecoration(element,record);}return doc;}
  async function load(url,refresh=false){
    if(loading&&!refresh)return loading;
    loading=(async()=>{
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),5000);
      try{const u=new URL(url,global.location.href);u.searchParams.set('stock',String(Math.floor(Date.now()/60000)));const response=await fetch(u.href,{cache:'no-store',signal:controller.signal});if(!response.ok)throw Error('Color availability could not load');accept(await response.json());try{localStorage.setItem(CACHE,JSON.stringify(current));}catch(_){}return current;}
      catch(_){if(!current)try{accept(JSON.parse(localStorage.getItem(CACHE)));}catch(_){}return current;}
      finally{clearTimeout(timer);}
    })();
    return loading;
  }
  function available(hex){const row=current?.colors.find(c=>c.hex===String(hex).toUpperCase());return !row||row.available;}
  function all(hexes){return hexes.every(available);}
  function applyDecoration(element,record){
    const ok=all(record.hexes);
    if(!ok){element.hidden=true;element.style.setProperty('display','none','important');element.dataset.stockUnavailable='true';}
    else if(element.dataset.stockUnavailable==='true'){
      element.hidden=record.hidden;
      if(record.display)element.style.setProperty('display',record.display,record.priority);else element.style.removeProperty('display');
      delete element.dataset.stockUnavailable;
    }
    return ok;
  }
  function decorate(element,hexes){
    let record=decorated.get(element);
    if(!record){record={hidden:element.hidden,display:element.style.getPropertyValue('display'),priority:element.style.getPropertyPriority('display')};decorated.set(element,record);}
    record.hexes=Array.isArray(hexes)?hexes.slice():[hexes];
    return applyDecoration(element,record);
  }
  function configurationHexes(manifest,c){
    const ids=[c.baseColorId], extra=[];
    if(c.templateId?.startsWith('teacher-sign-')){
      if(c.letterColorMode==='custom')ids.push(...(c.letterColorIds||[]));
      else if(c.letterColorMode==='single')ids.push(c.letterColorId);
      else extra.push(...(manifest.palettes?.find(p=>p.id===c.letterColorMode)?.colors||[]));
      if(c.titleId!=='none'&&(c.titleId!=='custom'||c.eyebrowText))ids.push(c.eyebrowColorId||c.letterColorId);
      // Compact current recipes omit the fixed white panel. Manufacturing also
      // requires the box's fixed yellow/emerald/charcoal parts from the manifest.
      if(c.styleId==='crayon')ids.push('cotton',...(manifest.crayon?.fixedColorIds||[]),...(c.crayonColorIds||[]));
    }else{
      ids.push(...(c.letterColorIds||[]));
      if(c.initial)ids.push(c.initialColorId);
      if(c.eyebrow)ids.push(c.eyebrowColorId);
      if(c.iconId)ids.push(...(manifest.icons?.find(i=>i.id===c.iconId)?.colorIds||[]));
    }
    return [...new Set([...ids.map(id=>manifest.colors?.find(color=>color.id===id)?.hex).filter(Boolean),...extra])];
  }
  function assertConfiguration(manifest,c){
    if(!current)throw Error('Color availability could not be verified. Please try again in a moment. Your design is saved unchanged.');
    const missing=configurationHexes(manifest,c).filter(hex=>!available(hex));
    if(missing.length){const names=missing.map(hex=>current.colors.find(row=>row.hex===hex.toUpperCase())?.name||hex);throw Error('Materials currently unavailable: '+names.join(', ')+'. Choose in-stock colors or another style. Your saved design has not been changed.');}
  }
  global.PCFilamentAvailability={load,available,all,decorate,configurationHexes,assertConfiguration,inspect:()=>current};
  if(typeof module==='object')module.exports={valid,accept,load,available,all,decorate,configurationHexes,assertConfiguration};
})(typeof window==='object'?window:globalThis);
